import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  subscribeAuthRecovery,
  reportAuthError,
  getAuthRecoveryState,
  type AuthRecoveryState,
} from '@/lib/authRecovery';

// Aviso global de sesión. Aparece cuando un error de token obliga a renovar la
// sesión y se queda visible si la renovación no fue posible, explicando qué pasó
// y ofreciendo reintentar o volver a iniciar sesión.
export default function SessionRecoveryBanner() {
  const [state, setState] = useState<AuthRecoveryState>(getAuthRecoveryState);
  const navigate = useNavigate();

  useEffect(() => subscribeAuthRecovery(setState), []);

  if (state.status === 'idle') {
    return null;
  }

  const isRecovering = state.status === 'recovering';

  return (
    <div className="fixed top-3 left-1/2 -translate-x-1/2 z-[120] w-[calc(100%-1.5rem)] max-w-2xl">
      <div className="rounded-lg border border-secondary-300 bg-secondary-50/95 backdrop-blur px-4 py-3 flex items-start gap-3">
        <span className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center shrink-0">
          <i
            className={
              isRecovering
                ? 'ri-refresh-line text-secondary-700 text-lg animate-spin'
                : 'ri-time-line text-secondary-700 text-lg'
            }
          ></i>
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-foreground-900">
            {isRecovering ? 'Reconectando tu sesión…' : 'Sesión finalizada por seguridad'}
          </p>
          <p className="text-xs text-foreground-600 mt-0.5 leading-relaxed">{state.message}</p>
          {!isRecovering && (
            <div className="flex flex-wrap items-center gap-2 mt-2.5">
              <button
                type="button"
                onClick={() => navigate('/login')}
                className="inline-flex items-center gap-1.5 rounded-md bg-secondary-600 hover:bg-secondary-700 text-background-50 text-xs font-semibold px-3 py-1.5 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-login-box-line"></i>
                Iniciar sesión
              </button>
              <button
                type="button"
                onClick={() => {
                  void reportAuthError();
                }}
                className="inline-flex items-center gap-1.5 rounded-md border border-secondary-300 text-secondary-800 hover:bg-secondary-100 text-xs font-semibold px-3 py-1.5 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-refresh-line"></i>
                Reintentar
              </button>
              <button
                type="button"
                onClick={() => window.location.reload()}
                className="inline-flex items-center gap-1.5 rounded-md border border-secondary-300 text-secondary-800 hover:bg-secondary-100 text-xs font-semibold px-3 py-1.5 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-restart-line"></i>
                Recargar
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}